import orgMana from './orgMana'

const zhCN = { orgMana: orgMana.zhCN }
const enUS = { orgMana: orgMana.enUS }
export default { zhCN, enUS }